import { extend } from '../../util/jquery.js';
export default class Security {
    constructor(
        d = {
            securityId: '',
            performanceId: ''
        }
    ) {
        extend(this, d);
        this._watchCount = 0;
    }
    get id() {
        if (this.isGuidSymbol) {
            return this.securityId;
        }
        return `${this.instrument}|${this.securityId}|${this.performanceId}`;
    }
    get instrument() {
        if (this.rtExchangeId && this.rtType && this.rtSymbol) {
            return `${this.rtExchangeId}.${this.rtType}.${this.rtSymbol}`;
        } else if (this.isGuidSymbol) {
            return this.securityId;
        }
        return '';
    }
    get quoteInstrument() {
        const exchangeId = this.rtMarketDataExchangeID
            ? this.rtMarketDataExchangeID
            : this.rtExchangeId;
        if (exchangeId && this.rtType && this.rtSymbol) {
            return `${exchangeId}.${this.rtType}.${this.rtSymbol}`;
        } else if (this.isGuidSymbol) {
            return this.securityId;
        }
        return '';
    }
    get MICMstarSymbol() {
        if (this.MICCode && this.mstarSymbol) {
            return `${this.MICCode}:${this.mstarSymbol}`;
        }
        return '';
    }
    get MICRTSymbol() {
        if (this.MICCode && this.rtSymbol) {
            return `${this.MICCode}:${this.rtSymbol}`;
        }
        return '';
    }
    watchCount(count) {
        if (arguments.length === 0) {
            return this._watchCount;
        }
        this._watchCount = count;
        return this;
    }
    isPermit() {
        return !this._noPermit;
    }
    isValid() {
        return !!(this.instrument || this.securityId || this.performanceId);
    }
    clone() {
        const clone = Object.assign(
            Object.create(Object.getPrototypeOf(this)),
            this
        );
        clone.watchCount(0);
        return clone;
    }
}
